export class ServicioEnviarMailModel {

    // request
    public remitente: string;
    public destinatario: string;
    public asunto: string;
    public cuerpoMail: string;

    // response
    public resultado: string;
    public codigo: string;
    public mensaje: string;

}